module.exports = __webpack_public_path__ + "img/SketchPngeffa85ec7fc07e2557ace285c6e80802b9c0152dffd5b57c65ece495041d3341.fccd8a60.png";